import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import pkg from '../package.json'

// Importar Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// Importar necesarios directamente
import store from './store'
import { installFetchTracker } from '@/utils/fetchTracker'

import '@/assets/fonts.css'
import './registerServiceWorker'

// Configurar Vuetify
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        }
      }
    }
  }
})

// Router is centralized in `src/router/index.js`
installFetchTracker()

const app = createApp(App).use(store)
app.use(router)
app.use(vuetify)
try {
  const appName = (pkg && pkg.name) ? pkg.name : 'app'
  const appVersion = (pkg && pkg.version) ? pkg.version : '0.0.0'
  const buildNumber = process.env.VUE_APP_BUILD_NUMBER || process.env.BUILD_NUMBER || ''
  const buildSuffix = buildNumber ? ` (build ${buildNumber})` : ''
  console.info(`[${appName}] version ${appVersion}${buildSuffix}`)
} catch (e) {
  // ignore
}
app.mount('#app')
